import React, {useEffect, useState} from 'react';
import {Button, Card, FloatButton, Form, Input, message, Modal} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";

const Project_projectmanagement = () => {


    document.title='项目管理'

    const [fetch_fetch_project_select_log, setfetch_fetch_project_select_log] = useState({message: '', value: '', time: 0})

    const navigate = useNavigate();

    let data_time = dayjs().unix();




    useEffect(() => {
        const usecookie = () => {


            if (Cookies.get('group') !== 'projectadmin') {

                message.error('无访问权限')
                navigate('/projectlogin?return_url=/project/projectmanagement')


            } else {


                switch (Cookies.get('userToken_chattool')) {

                    case undefined:

                        navigate('/projectlogin?return_url=/project/projectmanagement')


                        break;

                    default:



                        let data_time = dayjs().unix();

                        window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部
                        setfetch_fetch_project_select_log({message: '首次显示', time: data_time, value: ''})



                        break;


                }

            }
        }

        usecookie();
    }, []); // 空数组表示仅在组件挂载时执行



    const [return_data_fetch_fetch_project, setreturn_data_fetch_fetch_project] = useState({message: 0, info: [{id: '',uuid:'',userid:'', project_name: '', created: 0, country_name: '',country_code:'',country_allcode:'', children: {id: '', uuid:'',userid:'',user_created: 0, user_name: '', user_oname: '',user_password:'',country_code:''}}]})

    const fetch_fetch_project_body = new FormData();


    fetch_fetch_project_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_fetch_project_body.append('time', String(fetch_fetch_project_select_log.time));

    fetch_fetch_project_body.append('action', 'fetch_data');


    useEffect(() => {

        const data_async = async () => {

            const data_await = await fetch('https://chatv2.leytcn.com/api/project/fetch/fetch_project.php', {

                method: 'POST',
                body: fetch_fetch_project_body

            })


            const return_data = await data_await.json();



            switch (return_data.message) {


                case 2000:

//获取消息无需提示
                 /*   message.success(return_data.value)*/
                    let data_time = dayjs().unix();
                    setreturn_data_fetch_fetch_project(return_data)


                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/projectmanagement')


                    break


            }

        }


        if (fetch_fetch_project_select_log.message !== '') {

            data_async();


            setfetch_fetch_project_select_log({message: '', value: '', time: data_time})
        }


    }, [fetch_fetch_project_select_log]);


    const [add_project_FloatButton_modal_open, setadd_project_FloatButton_modal_open] = useState(false)
    const [add_project_FloatButton_select_log, setadd_project_FloatButton_select_log] = useState({message: '', value: '', time: 0})


    const [add_project_FloatButton_select_info, setadd_project_FloatButton_select_info] = useState({value1: '', value2: '', value3: '', time: 0})


    const add_project_FloatButton_modal_oncancel = () => {
        setadd_project_FloatButton_modal_open(false);
    }
    const add_project_FloatButton = () => {


        setadd_project_FloatButton_modal_open(true)
        setadd_project_FloatButton_select_log({message: 'add', value: '', time: data_time})

        setadd_project_FloatButton_select_info({value1: 'e1', value2: '', value3: '', time: data_time})

    }


    const [add_project_FloatButton_modal_finish_select_log, setadd_project_FloatButton_modal_finish_select_log] = useState({message: '', value: '', time: 0})

    const [add_project_FloatButton_modal_finish_select_info, setadd_project_FloatButton_modal_finish_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const add_project_FloatButton_modal_finish = (e1: any) => {


        setadd_project_FloatButton_modal_finish_select_log({message: 'finish', value: '', time: data_time})

        setadd_project_FloatButton_modal_finish_select_info({value1: e1, value2: '', value3: '', time: data_time})


    }


    const insert_insert_project_body = new FormData();


    insert_insert_project_body.append('finish_data', JSON.stringify(add_project_FloatButton_modal_finish_select_info.value1));

    insert_insert_project_body.append('userToken', String(Cookies.get('userToken_chattool')));

    insert_insert_project_body.append('time', String(add_project_FloatButton_modal_finish_select_info.time));

    insert_insert_project_body.append('action', 'insert_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/insert/insert_project.php', {

                method: 'POST',
                body: insert_insert_project_body


            })

            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setadd_project_FloatButton_modal_open(false)


                    setfetch_fetch_project_select_log({message: '创建成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/projectmanagement')


                    break


            }

        }


        if (add_project_FloatButton_modal_finish_select_log.message !== '') {

            data_async();


            setadd_project_FloatButton_modal_finish_select_log({message: '', value: '', time: 0})
        }
    }, [add_project_FloatButton_modal_finish_select_log]);

    const [edit_project_button_modal_open, setedit_project_button_modal_open] = useState(false)

    const [edit_project_button_select_info, setedit_project_button_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [edit_project_button_select_log, setedit_project_button_select_log] = useState({message: '', value: '', time: 0})
    const edit_project_button = (e1: any,country_name:any,country_code:any,country_allcode:any,project_name:any) => {



        edit_project_button_modal_form.setFieldValue('country_name',country_name)
        edit_project_button_modal_form.setFieldValue('country_code',country_code)
        edit_project_button_modal_form.setFieldValue('country_allcode',country_allcode)
        edit_project_button_modal_form.setFieldValue('project_name',project_name)


        setedit_project_button_modal_open(true)

        setedit_project_button_select_log({message: '', value: '', time: data_time})
        setedit_project_button_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

    const edit_project_button_modal_oncancel = () => {


        setedit_project_button_modal_open(false)

    }

    const [edit_project_button_modal_form] = Form.useForm();

    const [edit_project_button_modal_onfinish_select_log, setedit_project_button_modal_onfinish_select_log] = useState({message: '', value: '', time: 0})
    const [edit_project_button_modal_onfinish_select_info, setedit_project_button_modal_onfinish_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const edit_project_button_modal_onfinish = (e1: any) => {


        setedit_project_button_modal_onfinish_select_log({message: 'finish', value: '', time: data_time})
        setedit_project_button_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})


    }

    const update_project_body = new FormData();


    update_project_body.append('finish_data', JSON.stringify(edit_project_button_modal_onfinish_select_info.value1));

    update_project_body.append('userToken', String(Cookies.get('userToken_chattool')));

    update_project_body.append('time', String(edit_project_button_modal_onfinish_select_info.time));

    update_project_body.append('action', 'update_node');
    update_project_body.append('uuid', edit_project_button_select_info.value1);


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/update/update_project.php', {

                method: 'POST',
                body: update_project_body


            })

            const return_data = await data_await.json();
            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setedit_project_button_modal_open(false)


                    setfetch_fetch_project_select_log({message: '修改成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/projectmanagement')


                    break


            }

        }


        if (edit_project_button_modal_onfinish_select_log.message !== '') {


            data_async();

            setedit_project_button_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [edit_project_button_modal_onfinish_select_log]);


    const [del_project_button_modal_open, setdel_project_button_modal_open] = useState(false)
    const [del_project_button_select_info, setdel_project_button_select_info] = useState({value1: '', value2: '', value3: '', time: 0})
    const [del_project_button_select_log, setdel_project_button_select_log] = useState({message: '', value: '', time: 0})
    const del_project_button = (e1: any) => {


        setdel_project_button_modal_open(true)
        setdel_project_button_select_log({message: 'click', value: '', time: data_time})
        setdel_project_button_select_info({value1: e1, value2: '', value3: '', time: data_time})


    }

    const del_project_button_modal_open_oncancel = () => {


        setdel_project_button_modal_open(false)

    }

    const [del_project_button_modal_next_button_select_log, setdel_project_button_modal_next_button_select_log] = useState({message: '', value: '', time: 0})

    const del_project_button_modal_next_button = () => {

        setdel_project_button_modal_next_button_select_log({message: 'next', value: '', time: data_time})


    }


    const deldate_del_node_body = new FormData();


    deldate_del_node_body.append('uuid', del_project_button_select_info.value1);

    deldate_del_node_body.append('userToken', String(Cookies.get('userToken_chattool')));

    deldate_del_node_body.append('time', String(del_project_button_modal_next_button_select_log.time));

    deldate_del_node_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/deldate/del_node.php', {


                method: 'POST',
                body: deldate_del_node_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setdel_project_button_modal_open(false)


                    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/projectmanagement')


                    break


            }


        }


        if (del_project_button_modal_next_button_select_log.message !== '') {


            data_async();

            setdel_project_button_modal_next_button_select_log({message: '', value: '', time: 0})
        }

    }, [del_project_button_modal_next_button_select_log]);





    const [del_user_info_modal_open, setdel_user_info_modal_open] = useState(false)

    const [del_user_info_select_info, setdel_user_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [del_user_info_select_log, setdel_user_info_select_log] = useState({message: '', value: '', time: 0})
    const del_user_info = (e1: any,in1:any,in2:any,in3:any) => {

        setdel_user_info_select_log({message: 'click', value: '', time: data_time})

        setdel_user_info_modal_open(true);

        setdel_user_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setdel_user_info_modal_oncancel = () => {

        setdel_user_info_modal_open(false);
    }


    const [del_user_info_modal_next_button_select_log,setdel_user_info_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const del_user_info_modal_next_button = () => {

        let data_time=dayjs().unix();

        setdel_user_info_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_del_user_info,setreturn_data_del_user_info]=useState({});

    const del_user_info_body = new FormData();


    del_user_info_body.append('uuid', del_user_info_select_info.value1);

    del_user_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    del_user_info_body.append('time', String(del_user_info_modal_next_button_select_log.time));

    del_user_info_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/deldate/del_root_root_use.php', {


                method: 'POST',
                body: del_user_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setdel_user_info_modal_open(false)

                    setreturn_data_del_user_info(return_data);
                    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/projectmanagement')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/projectmanagement')


                    break

            }

        }


        if(del_user_info_modal_next_button_select_log.message!==''){

            data_async();
            setdel_user_info_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [del_user_info_modal_next_button_select_log]);








    const [edit_user_info_modal_open, setedit_user_info_modal_open] = useState(false)

    const [edit_user_info_select_info, setedit_user_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [edit_user_info_select_log, setedit_user_info_select_log] = useState({message: '', value: '', time: 0})
    const edit_user_info = (e1: any,in1:any,in2:any,in3:any) => {


        edit_user_info_modal_form.setFieldValue('input_value1',in1)
        edit_user_info_modal_form.setFieldValue('input_value2',in2)
        edit_user_info_modal_form.setFieldValue('input_value3',in3)

        setedit_user_info_select_log({message: 'click', value: '', time: data_time})

        setedit_user_info_modal_open(true);

        setedit_user_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setedit_user_info_modal_oncancel = () => {

        setedit_user_info_modal_open(false);
    }


    const [edit_user_info_modal_form]=Form.useForm();

    const edit_user_info_modal_initialValues={




    }

    const [edit_user_info_modal_onfinish_select_log,setedit_user_info_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [edit_user_info_modal_onfinish_select_info,setedit_user_info_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const edit_user_info_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setedit_user_info_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setedit_user_info_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_edit_user_info,setreturn_data_edit_user_info]=useState({});

    const edit_user_info_body = new FormData();

    edit_user_info_body.append('uuid', edit_user_info_select_info.value1);

    edit_user_info_body.append('finish_data', JSON.stringify(edit_user_info_modal_onfinish_select_info.value1));

    edit_user_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    edit_user_info_body.append('time', String(edit_user_info_modal_onfinish_select_info.time));

    edit_user_info_body.append('action', 'update_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/update/update_user_info.php', {


                method: 'POST',
                body: edit_user_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setedit_user_info_modal_open(false)

                    setreturn_data_edit_user_info(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    setfetch_fetch_project_select_log({message: 'ddd', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate(' /projectlogin')


                    break


            }

        }


        if(edit_user_info_modal_onfinish_select_log.message!==''){

            data_async();
            setedit_user_info_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [edit_user_info_modal_onfinish_select_log]);



    const [created_root_user_modal_open, setcreated_root_user_modal_open] = useState(false)

    const [created_root_user_select_info, setcreated_root_user_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [created_root_user_select_log, setcreated_root_user_select_log] = useState({message: '', value: '', time: 0})
    const created_root_user = (uuid:any,e1: any,e2:any) => {

        setcreated_root_user_select_log({message: 'click', value: '', time: data_time})

        setcreated_root_user_modal_open(true);

        setcreated_root_user_select_info({value1:uuid , value2: e1, value3: e2, time:data_time})
    }


    const setcreated_root_user_modal_oncancel = () => {

        setcreated_root_user_modal_open(false);
    }


    const [created_root_user_modal_form]=Form.useForm();

    const created_root_user_modal_initialValues={




    }

    const [created_root_user_modal_onfinish_select_log,setcreated_root_user_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [created_root_user_modal_onfinish_select_info,setcreated_root_user_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const created_root_user_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setcreated_root_user_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setcreated_root_user_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const created_root_user_body = new FormData();






    created_root_user_body.append('uuid', created_root_user_select_info.value1);
    created_root_user_body.append('country_name', created_root_user_select_info.value2);

    created_root_user_body.append('country_code', created_root_user_select_info.value3);

    created_root_user_body.append('finish_data', JSON.stringify(created_root_user_modal_onfinish_select_info.value1));


    created_root_user_body.append('userToken', String(Cookies.get('userToken_chattool')));

    created_root_user_body.append('time', String(created_root_user_modal_onfinish_select_info.time));

    created_root_user_body.append('action', 'insert_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/project/insert/insert_root_use.php', {


                method: 'POST',
                body: created_root_user_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setcreated_root_user_modal_open(false)

                    setfetch_fetch_project_select_log({message: '创建成功', value: '', time: data_time})

                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/projectlogin?return_url=/project/projectmanagement')


                    break


            }

        }


        if(created_root_user_modal_onfinish_select_log.message!==''){

            data_async();
            setcreated_root_user_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [created_root_user_modal_onfinish_select_log]);




    return (<div>

        {return_data_fetch_fetch_project.message!==2000?<></>:<>  {return_data_fetch_fetch_project.info.map(item1 => (<div>




                <Card style={{marginTop:10}}>

                    <div style={{display:'flex'}}>
                        <div style={{flexGrow:1}}>




                            <p></p>
                            公司名称: {item1.country_name}
                            <p></p>


                            公司营业执照代码:   <label>{item1.country_allcode}</label>

                            <p></p>

                            公司简称 {item1.country_code}

                            <p></p>

                            项目名：{item1.project_name}

                            <p></p>

                        </div>

                        <div>

                            <Button onClick={() => edit_project_button(item1.uuid,item1.country_name,item1.country_code,item1.country_allcode,item1.project_name)}>修改</Button>
                            <Button style={{marginLeft:10}} onClick={() => del_project_button(item1.uuid)}>删除</Button>

                        </div>


                    </div>
                    <Card>



                        <p></p>
                        <label>登录信息</label>
                        <p></p>
                        {item1.children.user_name !== null ?


                            <div>
                                <p></p>
                                user_name: {item1.children.user_name}

                                <p></p>
                                user_oname: {item1.children.user_oname}

                                <p></p>
                                user_password: {item1.children.user_password}

                                <p></p>
                                country_code: {item1.country_code}

                                <p></p>


                                <Button onClick={()=>edit_user_info(item1.children.uuid,item1.children.user_name,item1.children.user_oname,item1.children.user_password)}>修改信息</Button>
                                <Button style={{marginLeft:10}} onClick={()=>del_user_info(item1.children.uuid,item1.children.user_name,item1.children.user_oname,item1.children.user_password)}>删除账户</Button>


                            </div>


                            : <div>


                                <Button onClick={()=>created_root_user(item1.uuid,item1.country_name,item1.country_code)}>创建管理员用户</Button>
                            </div>


                        }

                    </Card>

                </Card>


            </div>

        ))}</>}







        <Modal open={del_user_info_modal_open} onCancel={setdel_user_info_modal_oncancel} footer={null} title={'是否删除管理员身份？'}>


            <Button onClick={del_user_info_modal_next_button}>

                确认删除
            </Button>


            <Button style={{marginLeft:10}} onClick={setdel_user_info_modal_oncancel}>

                取消
            </Button>


        </Modal>





        <Modal open={edit_user_info_modal_open} onCancel={setedit_user_info_modal_oncancel} footer={null} title={'编辑用户信息'}>




            <Form form={edit_user_info_modal_form} initialValues={edit_user_info_modal_initialValues} onFinish={edit_user_info_modal_onfinish}>

                <label>user_name</label>

                <Form.Item name={'input_value1'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>user_oname</label>

                <Form.Item name={'input_value2'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>


                <label>user_password</label>

                <Form.Item name={'input_value3'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>



                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft:10}} onClick={setedit_user_info_modal_oncancel}>取消</Button>

            </Form>


        </Modal>



        <Modal open={edit_project_button_modal_open} onCancel={edit_project_button_modal_oncancel} footer={null}
               title={'修改信息'}>


            <Form form={edit_project_button_modal_form} onFinish={edit_project_button_modal_onfinish}>



                <label>公司名称</label>
                <Form.Item name={'country_name'}>


                    <Input>


                    </Input>

                </Form.Item>




                <label>公司营业执照信用代码</label>
                <Form.Item name={'country_allcode'}>


                    <Input>


                    </Input>

                </Form.Item>

                <label>公司简称</label>
                <Form.Item name={'country_code'}>


                    <Input>


                    </Input>

                </Form.Item>

                <label>项目名</label>
                <Form.Item name={'project_name'}>


                    <Input>


                    </Input>

                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>修改</Button>

                <Button onClick={edit_project_button_modal_oncancel} style={{marginLeft: 10}}>取消</Button>
            </Form>
        </Modal>


        <FloatButton icon={<PlusOutlined/>} tooltip="新增项目" onClick={add_project_FloatButton}/>


        <Modal open={add_project_FloatButton_modal_open} onCancel={add_project_FloatButton_modal_oncancel} footer={null}
               title={'添加公司'}>

            <Form onFinish={add_project_FloatButton_modal_finish}>


                <label>公司名称</label>
                <Form.Item name={'input_value1'} rules={[{message:'必填',required:true}]}>


                    <Input>


                    </Input>


                </Form.Item>


                <label>营业执照信用代码</label>
                <Form.Item name={'input_value2'} rules={[{message:'必填',required:true}]}>


                    <Input>


                    </Input>


                </Form.Item>


                <label>公司代码（简码）</label>
                <Form.Item name={'input_value3'} rules={[{message:'必填',required:true}]}>


                    <Input>


                    </Input>


                </Form.Item>


                <label>用途（选填）</label>
                <Form.Item name={'input_value4'}>


                    <Input>


                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>添加</Button>

                <Button style={{marginLeft: 10}} onClick={add_project_FloatButton_modal_oncancel}>取消</Button>
            </Form>


        </Modal>





        <Modal open={created_root_user_modal_open} onCancel={setcreated_root_user_modal_oncancel} footer={null} title={'创建管理员用户'}>




            <Form form={created_root_user_modal_form} initialValues={created_root_user_modal_initialValues} onFinish={created_root_user_modal_onfinish}>

                <label>用户名</label>

                <Form.Item name={'input_value1'}  rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>

                </Form.Item>


                <label>附加名（姓名）</label>
                <Form.Item name={'input_value2'}  rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>密码</label>
                <Form.Item name={'input_value3'} rules={[{message:'必填项',required:true}]}>

                    <Input >



                    </Input>


                </Form.Item>



                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft:10}} onClick={setcreated_root_user_modal_oncancel}>取消</Button>

            </Form>


        </Modal>




        <Modal open={del_project_button_modal_open} onCancel={del_project_button_modal_open_oncancel}
               title={'是否确认删除'} footer={null}>

            <Button onClick={del_project_button_modal_next_button}>确认删除</Button>

            <Button style={{marginLeft: 10}} onClick={del_project_button_modal_open_oncancel}>取消</Button>
        </Modal>

    </div>)
}


export default Project_projectmanagement;
